export default __webpack_public_path__ + "static/media/disconnect.05e7cd8a.wav";